import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { SuccessIcon , Info_Yellow } from "../../assets/images/assetsAll"
import "./SuccessfulPayment.scss"
import {  deleteCookie } from "../../utils/utils";

function SuccessfulPayment() {
    const history=useHistory()
    const [enableCashPayment, setEnableCashPayment] = useState();
    const [isKeyMissing, setIsKeyMissing] = useState(false);

    useEffect(() => {
        const enableWithoutDocs = localStorage.getItem("enable_cash_payment_without_docs");
        console.log("enableWithoutDocs", enableWithoutDocs);
        
        if (enableWithoutDocs === null) {
            setIsKeyMissing(true);  
            setEnableCashPayment(false); 
        } else {
            setIsKeyMissing(false);  
            setEnableCashPayment(!!JSON.parse(enableWithoutDocs));
        }
    }, []);
    
    const orderid = JSON.parse(sessionStorage.getItem("user_details"))?.order_id
    

    useEffect(() => {
        deleteCookie(["offline_unique_code"])
    }, [])
    
  return (
      <div className='offline-payment-success-wrapper'>
          <div className="offline-payment-success-content">
              <div className="offline-payment-success-img">
                  <img src={!isKeyMissing ? (enableCashPayment ? SuccessIcon : Info_Yellow) : SuccessIcon } alt="success" />
              </div>
              <div className="offline-payment-success-content-div">
                  <div className="offline-payment-success-header">Payment initiated successfully</div>
                  {/* <div className="offline-payment-success-orderid">{ orderid}</div> */}
                  {isKeyMissing && orderid && (
                        <div className="offline-payment-success-orderid">{orderid}</div>
                    )}
                    {!isKeyMissing && orderid && (
                  <div className="offline-payment-success-enable"> {enableCashPayment ? `The order (${orderid}) has been successfully created, and customer can view the payment receipt on their browser/app. Please upload the cash receipt as soon as possible for finance to verify the payment` : `Your request for order (${orderid}) creation has been successfully submitted. Order will be created after finance team verifies the payment. Please inform the customer of the same.`}</div>)}

              </div>
          </div>
          <div className="offline-payment-success-done-btn-div">
              <button onClick={()=>{history.push("/booking-list")}} className="offline-payment-success-done-btn">Done</button>
          </div>
    </div>
  )
}

export default SuccessfulPayment